import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { ReactComponent as UploadFileIcon } from "assets/images/svg/upload-file-icon.svg";
import { ReactComponent as TechnicalSanctionDocumentIcon } from "assets/images/svg/view-technical-sanction-document.svg";
import { ReactComponent as DemandEstimationDocumentIcon } from "assets/images/svg/view-demand0estimation-document.svg";
import { ReactComponent as AddEditMeter } from "assets/images/addEdit.svg";
import { ReactComponent as PreviewDocuments } from "assets/images/svg/preview-documents-icon.svg";

export const UploadIcon = styled(UploadFileIcon)(
  ({ theme }) => `
      fill: ${theme.palette.primary.main};
      height: 17px;
      width: 17px;
  `
);

export const ViewTechnicalSanctionDocumentIcon = styled(
  TechnicalSanctionDocumentIcon
)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
`
);

export const AddEditMeterIcon = styled(AddEditMeter)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
`
);
export const ViewDemandEstimationDocumentIcon = styled(
  DemandEstimationDocumentIcon
)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
`
);

export const PreviewPendingDocumentsIcon = styled(PreviewDocuments)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
`
);

export const StyledIconButton = styled(IconButton)`
  height: 34px;
  width: 34px;
`;

export const StyledGrid = styled(DataGrid)`
  .MuiTablePagination-selectLabel,
  .MuiTablePagination-displayedRows {
    margin: 0;
  }
`;
